require("../coord/cartesian/AxisModel");

require("./axis/CartesianAxisView");


//////////////////
// WEBPACK FOOTER
// ../~/echarts/lib/component/axis.js
// module id = cmdg
// module chunks = 0